// Kept free of imports: storage.ts reads these, and anything it pulls in ends up in an import cycle.
export const DEFAULT_SIDEBAR_WIDTH = 235;
export const MIN_SIDEBAR_WIDTH = 200;
export const MAX_SIDEBAR_WIDTH = 480;

export const DEFAULT_PLAN_SIDEBAR_WIDTH = 320;
export const MIN_PLAN_SIDEBAR_WIDTH = 240;
export const MAX_PLAN_SIDEBAR_WIDTH = 560;

/** No single sidebar may eat more than this share of the window, or the calendar is left unusable. */
const MAX_VIEWPORT_SHARE = 0.35;

/** Widest a sidebar may get on the current screen — the fixed cap, unless the window is too narrow for it. */
export const maxSidebarWidth = (min: number, max: number) =>
  Math.max(min, Math.min(max, Math.round(window.innerWidth * MAX_VIEWPORT_SHARE)));

export const clampSidebarWidth = (width: number, min: number, max: number) =>
  Math.min(Math.max(width, min), maxSidebarWidth(min, max));
